<template>
  <div class="flex rounded-md shadow-sm">
    <div class="relative z-10 flex flex-grow items-stretch">
      <input
        ref="inputRef"
        type="text"
        class="w-full rounded-none rounded-l-md border-neutral-80 pl-4 text-neutral-40 focus:border-primary-60 focus:ring-primary-60 sm:text-sm"
        :value="value"
        readonly
        @focus="selectAll"
      />
      <SimpleButton theme="primary" class="rounded-none rounded-r-md" @click="copy()">
        <template #leading
          ><ClipboardCopyIcon v-if="!copied" class="h-5 w-5 text-neutral-100" /><ClipboardCheckIcon
            v-else
            class="h-5 w-5 text-neutral-100"
        /></template>
        <span v-if="!copied"> {{ t("button.onclick") }}</span>
        <span v-else> {{ t("button.clicked") }}</span></SimpleButton
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { ClipboardCopyIcon, ClipboardCheckIcon } from "@heroicons/vue/outline";
import SimpleButton from "@atoms/SimpleButton.vue";
import { useClipboard } from "@vueuse/core";

// Props
const props = withDefaults(
  defineProps<{
    value: string;
  }>(),
  {
    value: "",
  },
);

const { t } = useI18n();
const inputRef = ref();
const { copy, copied } = useClipboard({ source: props.value });

const selectAll = () => {
  inputRef.value.select();
};
</script>

<i18n lang="json">
{
  "es": {
    "button": { "onclick": "Copiar", "clicked": "Copiado" }
  },
  "pt": {
    "button": { "onclick": "Copiar", "clicked": "Copiado" }
  }
}
</i18n>
